var MediatorGDI = {
  instance: function () {
    if (!MediatorGDI.instance) {
      MediatorGDI.instance = this;
    }
    return MediatorGDI.instance;
  },
  main: {},
  graphProductionUnits: {},
  headerPgdi: {},
  header: {},
  footer: {},
  data: {},
  unit: [],
  bkpDataInitial: null,
  bkpDataFinal: {},
  bkpArea: null,

  async notify(sender, event) {
    switch (event) {
      case "init":
        this.main = sender;
        let dataToGraphGDI = JSON.parse(localStorage.getItem('dataToGraphGDI'));

        if (dataToGraphGDI) {
          this.main.waitingLoadChart = true;
          setTimeout(() => {
            this.graphProductionUnits.loadChart(
              populateGraphAdherenceUnits(dataToGraphGDI)
            );
            this.footer.globalAdherence = dataToGraphGDI.adherenceGlobal;
          }, 50);
          this.main.waiting = false;
        }
        break;

      case "init-header":
        this.header = sender;
        if (this.bkpDataInitial != null) {
          this.header.initialDate = this.bkpDataInitial
          this.header.finalDate = this.bkpDataFinal
          this.header.area = this.bkpArea
        }
        break;

      case "init-header-pgdi":
        this.headerPgdi = sender;
        this.headerPgdi.unit = this.unit;
        this.headerPgdi.areaGDI = this.header.area;
        this.headerPgdi.initialDate = this.header.initialDate
        this.headerPgdi.finalDate = this.header.finalDate
        break;

      case "back-to-gdi":
        this.bkpArea = this.header.area
        this.bkpDataInitial = this.header.initialDate
        this.bkpDataFinal = this.header.finalDate
        break;

      case "init-footer":
        this.footer = sender;
        break;

      case "loading-infos":
        this.data = sender;
        break;

      case "init-graph-productionUnits":
        this.graphProductionUnits = sender;
        break;

      case "show-pgdi-info":
        showScreenPGDIData(sender);
        break;

      case "quantityIndicators":
        this.quantity = sender;
        console.log(this.quantity);
        this.graphProductionUnits.screenIndicators = this.quantity;
        break;

      case "changeScreen":
        this.parameterSearch = sender;
        localStorage.setItem('parameterSearchGDI', JSON.stringify(sender));
        this.main.waiting = true;
        await this.main.getAllAdherenceIndicatorsByUnits(this.parameterSearch);
        this.main.waiting = false;
        setTimeout(() => {
          if (this.main.res == 200) {
            localStorage.setItem('dataToGraphGDI', JSON.stringify(this.data));
            this.graphProductionUnits.loadChart(
              populateGraphAdherenceUnits(this.data)
            );
            this.footer.globalAdherence = this.data.adherenceGlobal;
          }
        }, 50);
        break;
    }
  },
};

function showScreenPGDIData(unitName) {
  var listProductionUnits = MediatorGDI.data.productionUnits;
  let unit = listProductionUnits.find((u) => u.name == unitName);

  MediatorGDI.main.showScrenPGDI(unit.id);
  MediatorGDI.unit = unit;
}

function populateGraphAdherenceUnits(data) {
  let adherenceMinimumGDI = data.adherenceMinimumResults;
  let adherenceUnits = data.adherenceResults;

  let listProductionUnits = [];

  for (var unit in adherenceMinimumGDI) {
    var elementResult = adherenceMinimumGDI[unit];
    if (elementResult >= 0) {
      let element = {
        key: unit,
        x: unit,
        y: adherenceUnits[unit],
        goals: [
          {
            name: "Aderência Mínima (%)",
            value: elementResult ? elementResult : 0,
            strokeWidth: 3,
            strokeHeight: 15,
            strokeDashArray: 5,
            strokeColor: "#000",
          },
          {
            name: "Ocor.Tratadas (%)",
            value: data.ocurrenceResults[unit]
              ? data.ocurrenceResults[unit]
              : 0,
            strokeWidth: 10,
            strokeHeight: 0,
            strokeLineCap: "round",
            strokeColor: "#FF7100",
          },
        ],
      };
      listProductionUnits.push(element);
    }
  }

  let listProductionUnitsFiltred = listProductionUnits.sort((a, b) => parseFloat(a.y) > parseFloat(b.y) ? 1 : parseFloat(a.y) < parseFloat(b.y) ? -1 : 0);

  return listProductionUnitsFiltred;
}

export default MediatorGDI;